module.exports = __webpack_public_path__ + "img/huitre-en-ligne-boutrais_medium.cf64e480.png";